import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { deleteTrainingTopic } from "../../../actions/admin/certification/training_topic_action";
import { deleteTrainingModule } from "../../../actions/admin/certification/training_module_action";
import LoadingOverlay from "react-loading-overlay";
import { ToastContainer, toast } from "react-toastify";
import { getAllTrainingCourseList } from "../../../actions/admin/certification/training_course_action";

const ViewTrainingCourseModel = (props) => {
  const [show, setShow] = useState(props.show);
  const moduleState = useSelector((state) => state.trainingModuleReducer);
  const topicState = useSelector((state) => state.trainingTopicReducer);
  const handleClose = () => {
    props.handelClosePopup();
    setShow(false);
  };
  const dispatch = useDispatch();

  const deleteModules = (mod) => {
    dispatch(deleteTrainingModule({ module_id: mod }));
    props.handelClosePopup();
    setShow(false);
    dispatch(getAllTrainingCourseList());
  };

  const deleteModuleTopic = (id) => {
    dispatch(deleteTrainingTopic({ topic_id: id }));
    props.handelClosePopup();
    setShow(false);
    dispatch(getAllTrainingCourseList());
  };


   if(moduleState.is_done || topicState.loading){
    // toast("Record Deleted Successfully!", {
    //   type: "success",
    //   position: "top-center",
    // });
   }

  return (
    <div>
      <Modal
        className="custom-modal"
        show={show}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>Training Course Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="err-model-body scr-x">
          <ol type="I">
          
              {props.data &&
                props.data.map((obj, i) => (
             
                    <li className="module-li">
                      {i + 1 + ". " + obj.name}{" "}
                      <button
                        className="btn approve_btn btn-common"
                        type="button"
                        onClick={() => deleteModules(obj.id)}
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i> 
                      </button>
                      {obj.topics && (
                        <ol className="topic-li" type="I">
                          {obj.topics.map((top, i) => (
                            <li>
                              {" "}
                              {i + 1 + ". " + top.name}
                              <button
                                className="btn approve_btn btn-common"
                                type="button"
                                onClick={() => deleteModuleTopic(top.id)}
                              >
                                <i class="fa fa-trash" aria-hidden="true"></i>{" "}
                                
                              </button>
                            </li>
                          ))}
                        </ol>
                      )}
                    </li>                 
                ))}           
          </ol>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewTrainingCourseModel;
